// https://tanstack.com/router/latest/docs/framework/react/guide/custom-link#react-aria-components-example
import { createLink } from '@tanstack/react-router'
import { composeRenderProps, type LinkProps, Link as RACLink } from 'react-aria-components'
import { ButtonContent, button, type Variants } from './button'

export interface LinkButtonProps extends Omit<LinkProps, 'isDisabled'>, Variants {
  disabled?: boolean
  children?: React.ReactNode
}

function MyLinkButton({
  className,
  variant = button.defaultVariants.variant,
  size,
  children,
  disabled,
  ...props
}: LinkButtonProps) {
  return (
    <RACLink
      {...props}
      isDisabled={disabled}
      className={composeRenderProps(className, (className, renderProps) =>
        button({
          ...renderProps,
          variant,
          size,
          className,
        }),
      )}
    >
      <ButtonContent variant={variant}>{children}</ButtonContent>
    </RACLink>
  )
}

export const LinkButton = createLink(MyLinkButton)
